/*global google*/
/* eslint-disable */

import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from 'react-google-maps'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import Select from 'react-select'
import cookie from 'react-cookies'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'

const {compose, withProps} = require('recompose')

class AddCity extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      Province: [],

      latitude: 35.74287570972717,
      longitude: 51.54944953647805,
      error: '',
      selectedOption: null,
      provinceValue: '',
      redirect: false
    }
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    this.setState({
      provinceValue: selectedOption.value
    })

    console.log(`Option selected:`, selectedOption)
  }

  componentDidMount() {
    http
      .get(`report/base/province/?export=${1}`, {})
      .then((response) => {
        if (response.data.error == null) {
          let Province = response.data.object.result
          for (let i = 0; i < Province.length; i++) {
            Province[i]['value'] = Province[i].provinceId
            Province[i]['label'] = Province[i].name
          }
          this.setState({
            Province: response.data.object.result
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submitForm(e) {
    e.preventDefault()
  }

  addCity() {
    var name = document.getElementById('name').value
    var province = this.state.provinceValue
    var errorForm = false
    var nameError = false
    var provinceError = false
    var positionError = false
    if (name == '') {
      errorForm = true
      nameError = true
      message.error('نام شهر را وارد کنید')
    } else {
      if (!nameError) {
        this.setState({
          error: 'none'
        })
      }
    }
    if (this.state.latitude == 0 && this.state.longitude == 0) {
      errorForm = true
      positionError = true
      message.error('موقعیت شهر را از روی نقشه تعیین کنید')
    } else {
      if (!positionError) {
        this.setState({error: ''})
      }
    }
    if (province == '') {
      errorForm = true
      provinceError = true
      message.error('استان را وارد کنید')
    } else {
      if (!province) {
        this.setState({
          error: ''
        })
      }
    }
    if (!errorForm) {
      const token = sessionStorage.getItem('accessToken')
      var data = {
        name: name,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
        provinceId: province
      }
      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_ADD_CITY}`, data, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then((response) => {
          if (response.data.error == null) {
            message.success('شهر جدید اضافه شد.لطفا صبر کنید')
            this.setState({
              redirect: true
            })
            setInterval(() => {
              window.location.assign('/Cities')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  renderRedirect = () => {
    // if (this.state.redirect) {
    //     return <Redirect to='/Cities'/>
    // }
  }

  render() {
    const {Province} = this.state
    const {selectedOption} = this.state

    const MapWithADrawingManager = compose(
      withProps({
        googleMapURL:
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyAZt97TFAMPbJkQreQAb9KyRx3Qu7dOcxw&v=3.exp&libraries=geometry,drawing,places',
        loadingElement: <div style={{height: `100%`}} />,
        containerElement: <div style={{height: `300px`}} />,
        mapElement: <div style={{height: `100%`}} />
      }),
      withScriptjs,
      withGoogleMap
    )((props) => (
      <GoogleMap
        defaultCenter={new google.maps.LatLng(this.state.latitude, this.state.longitude)}
        defaultZoom={8}
        ref={(node) => (this.myMap = node)}
        onClick={(e) => {
          this.setState({
            latitude: e.latLng.lat(),
            longitude: e.latLng.lng()
          })
        }}
      >
        <Marker
          defaultPosition={{lat: this.state.latitude, lng: this.state.longitude}}
          ref={(node) => (this.marker = node)}
        />
      </GoogleMap>
    ))

    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <MDBBreadcrumb>
            <MDBBreadcrumbItem>بروزرسان</MDBBreadcrumbItem>
            <MDBBreadcrumbItem>لیست شهر ها</MDBBreadcrumbItem>
            <MDBBreadcrumbItem active>افزودن شهر</MDBBreadcrumbItem>
          </MDBBreadcrumb>
          <MapWithADrawingManager />

          <form className="inlineForm" onSubmit={this.submitForm.bind(this)}>
            <figure>
              <label>نام شهر : (الزامی)</label>
              <input type="text" className="form-control" id="name" name="name" />
            </figure>
            <figure>
              <label>استان را انتخاب کنید (الزامی)</label>

              <Select value={selectedOption} onChange={this.handleChange} options={this.state.Province} />
            </figure>
            <figure>
              <label className="hiddenLabel">نام شهر : (الزامی)</label>
              <button className="btn btn-primary form-control btn-sm" onClick={this.addCity.bind(this)}>
                ثبت شهر جدید
              </button>
              {this.renderRedirect()}
            </figure>
          </form>
        </div>
      </div>
    )
  }
}

export default AddCity
